import { ZaiChatCenterStage } from '@winnin/zai-chat'
import '@winnin/zai-chat/styles.css'

import { FeatureFlagsStore } from 'stores'

import { ZaiIframeProvider } from '../zai-iframe-provider'

import './zai-chat-desktop-page.styles.scss'

export function ZaiChatDesktopPage() {
  const isNativeZaiChatEnabled = FeatureFlagsStore.getFeatureFlag('isNativeZaiChatEnabled')
  const isZaiRagEnabled = FeatureFlagsStore.getFeatureFlag('isZaiRagEnabled')

  return (
    <div className="ZaiChatDesktopPage">
      {isNativeZaiChatEnabled ? (
        <ZaiChatCenterStage isZaiRagEnabled={isZaiRagEnabled} />
      ) : (
        <ZaiIframeProvider module="center-stage" />
      )}
    </div>
  )
}
